/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/banner_templates/update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdBannerTemplatesUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdBannerTemplatesUpdateArchivedStateProps,
  EngagementAppGroupIdBannerTemplatesUpdateArchivedStateResult,
} from "./types";

export const postEngagementAppGroupIdBannerTemplatesUpdateArchivedState = reactQueryMutationAdapter(
  engagementAppGroupIdBannerTemplatesUpdateArchivedStateCacheKeys,
  ({
    appGroupId,
    ids,
    mark_as_archived,
  }: PostEngagementAppGroupIdBannerTemplatesUpdateArchivedStateProps): Promise<EngagementAppGroupIdBannerTemplatesUpdateArchivedStateResult> => {
    return fetch(
      `/engagement/${appGroupId}/banner_templates/update_archived_state`,
      "POST",
      { ids, mark_as_archived },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
